import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Tracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    // Basic page view
    window.gtag("event", "page_view", {
      page_path: location.pathname,
    });

    /**
     * OPTIONAL:
     * If you pass event data to window.__EVENT__
     * normalize tags so they always live at root level
     */
    const eventData = window.__EVENT__;

    if (eventData) {
      const tags =
        eventData.tags ??
        eventData.single_content?.tags ??
        [];

      if (tags.length > 0) {
        window.gtag("event", "event_tags_exposed", {
          page_path: location.pathname,
          tags: tags.join(","), // GA prefers string
        });
      }
    }
  }, [location.pathname]);

  return null;
};

export default Tracking;
